export enum DropzoneRootDataAttributes {
  /**
   * Present when files are being dragged over the dropzone.
   */
  dragging = 'data-dragging',
  /**
   * Present when the dropzone is disabled.
   */
  disabled = 'data-disabled',
}
